import { api } from '@/shared/api/axios';

export interface EmployeeStatsResponse {
  totalLeads: number;
  leadsToday: number;
  leadsWeek: number;
  scansToday: number;
  pipeline: Record<string, number>;
}

export const fetchEmployeeStats = async (): Promise<EmployeeStatsResponse> => {
  const { data } = await api.get<EmployeeStatsResponse>('/api/my/stats');
  return data;
};
